import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import './Modal.css';

export default function ModalRegistro({ onClose, onSwitch }) {
  const { registro } = useAuth();
  const [form, setForm]   = useState({ nombre:'', apellido:'', email:'', password:'', telefono:'', rol:'estudiante' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const u = await registro(form);
      toast.success(`¡Cuenta creada! Bienvenido/a, ${u.nombre} 🎉`);
      onClose();
    } catch (err) {
      const msgs = err.response?.data?.errors;
      setError(msgs ? msgs.map(e => e.msg).join(' · ') : err.response?.data?.msg || 'Error al registrarse');
    } finally { setLoading(false); }
  };

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal fade-up">
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>Crear cuenta</h2>
        <p className="modal-sub">Únete a la comunidad Red Cimarrona</p>

        <form onSubmit={submit}>
          <div className="f-row">
            <div className="f-group">
              <label className="f-lbl">Nombre</label>
              <input className="f-inp" name="nombre" placeholder="Tu nombre" value={form.nombre} onChange={handle} required />
            </div>
            <div className="f-group">
              <label className="f-lbl">Apellido</label>
              <input className="f-inp" name="apellido" placeholder="Tu apellido" value={form.apellido} onChange={handle} required />
            </div>
          </div>
          <div className="f-group">
            <label className="f-lbl">Correo electrónico</label>
            <input className="f-inp" name="email" type="email" placeholder="correo@ejemplo.com" value={form.email} onChange={handle} required />
          </div>
          <div className="f-group">
            <label className="f-lbl">Contraseña</label>
            <input className="f-inp" name="password" type="password" placeholder="Mínimo 6 caracteres" value={form.password} onChange={handle} required />
          </div>
          <div className="f-group">
            <label className="f-lbl">Teléfono de contacto</label>
            <input className="f-inp" name="telefono" type="tel" placeholder="+52 ..." value={form.telefono} onChange={handle} required />
          </div>
          <div className="f-group">
            <label className="f-lbl">Tipo de cuenta</label>
            <select className="f-inp" name="rol" value={form.rol} onChange={handle}>
              <option value="estudiante">Estudiante</option>
              <option value="publico">Público general</option>
              <option value="maestro">Maestro (requiere validación)</option>
            </select>
          </div>
          {error && <p className="f-err mb-3">{error}</p>}
          <button className="btn btn-v btn-full btn-lg" disabled={loading}>
            {loading ? 'Creando cuenta...' : 'Crear cuenta'}
          </button>
        </form>

        <p className="modal-switch">
          ¿Ya tienes cuenta? <span onClick={onSwitch}>Inicia sesión</span>
        </p>
      </div>
    </div>
  );
}
